import { isEmpty } from 'lodash';
import moment from 'moment';

import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import authenticationUtils from '../../utils/authenticationUtils';
import { OutstandingFeeReportParams } from '../../modules/OutstandingFeeByClassReport/types';

const getQueryParams = (params: OutstandingFeeReportParams): string => {
  const { asOnDate, session, grade, division, page, perPage } = params;
  const encodedAsOnDate = encodeURIComponent(
    `${moment(asOnDate).format('YYYY-MM-DD')} 23:59:59`
  );
  return [
    `asOnDate=${encodedAsOnDate}`,
    `session=${!isEmpty(session) && session !== 'All' ? session : ''}`,
    `grade=${!isEmpty(grade) && grade !== 'All' ? grade : ''}`,
    `division=${!isEmpty(division) && division !== 'All' ? division : ''}`,
    `page=${page}`,
    `perPage=${perPage}`
  ].join('&');
};

const getOutstandingFeeByClassReport = (params: OutstandingFeeReportParams) =>
  httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/reports/outstanding-fees-by-class?${getQueryParams(params)}`,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );

export { getOutstandingFeeByClassReport };
